"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressRoutes = void 0;
var AddressRoutes;
(function (AddressRoutes) {
    AddressRoutes["BasePrefix"] = "addresses";
    AddressRoutes["ById"] = ":addressId";
    AddressRoutes["AllByClient"] = "all/:clientId";
    AddressRoutes["List"] = "list";
})(AddressRoutes = exports.AddressRoutes || (exports.AddressRoutes = {}));
